import React, { Component } from "react";

// Assets
import foodImage from "../../Assets/foodImage.svg";

export default class CalcFoodData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBtn: false,
      totalCnt: 0,

      chartShow: false,

      foodData: [
        { name: "Methi", carbsCnt: 70 },
        { name: "Palak", carbsCnt: 80 },
        { name: "Shepu", carbsCnt: 10 },
        { name: "Aloo", carbsCnt: 20 },
        { name: "Bhendi", carbsCnt: 30 },
        { name: "Chole", carbsCnt: 40 },
        { name: "Panner", carbsCnt: 50 },
        { name: "Karl", carbsCnt: 60 },
        { name: "Methi", carbsCnt: 80 },
      ],
    };
  }

  chartShowChange = () => {
    this.setState({ chartShow: !this.state.chartShow });
  };

  cartCard() {
    return (
      <div className="Calculation_CartCard">
        <div className="Calculation_CartImageBlock">
          <img src={foodImage} alt="Food Image" />
          <div className="Calculation_CartFoodName">Poha</div>
        </div>
        <div className="Calculation_CartCarbsBlock">
          <div className="Calculation_CartCarbsCnt">70 gm carbs</div>
          <button className="Calculation_CartMinus"></button>
          <div className="Calculation_CartCounter">1</div>
          <button className="Calculation_CartPlus"></button>
        </div>
      </div>
    );
  }

  foodCart() {
    return (
      <div className="Calculation_FoodCartBlock">
        <div className="Calculation_FoodCartTitleBlock">
          <div className="Calculation_FoodCartName">Food Cart</div>
          <button
            className="Calculation_FoodCartBtn"
            onClick={this.chartShowChange}
          ></button>
        </div>
        <div className="Calculation_FoodCartHolder">
          {[...Array(10)].map(() => {
            return <>{this.cartCard()}</>;
          })}
        </div>
        <div className="Calculation_TotalNextBtn">
          <div className="Calculation_TotalCarbs">
            <div className="title">Total Carbohydrate:</div>
            <div className="count">220 gm carbs</div>
          </div>
          <div
            className="Calculation_CartNextBtn"
            onClick={() => {
              this.props.renderPage(2);
            }}
          >
            Next
          </div>
        </div>
      </div>
    );
  }

  foodCard() {
    return this.state.foodData.map((food) => {
      return (
        <div className="Calculation_FoodCard">
          <img src={foodImage} />
          <div className="Calculation_FoodDetails">
            <div className="Calculation_DetailBlock">
              <div className="Calculation_CardTitle">{food.name}</div>
              <div className="Calculation_CarbsInfo">{food.carbsCnt} gm</div>
            </div>
            <div className="Calculation_FoodCounterBlock">
              <button className="calcMinus"></button>
              <div className="calcCounter">0</div>
              <button
                className="calcPlus"
                onClick={() => {
                  this.setState({ showBtn: true });
                }}
              ></button>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="Calculation_CalcFoodDataBlock">
        <div className="Calculation_CalcSearchBarBlock">
          <input
            type="search"
            className="Calculation_SearchBar"
            placeholder="Search Food"
          />
          {this.state.showBtn ? (
            <button
              className="Calculation_CartBtn"
              onClick={this.chartShowChange}
            ></button>
          ) : (
            <></>
          )}
        </div>
        <div className="Calculation_CalcHolder">
          <div className="Calculation_PopularFoodBlock">
            <div className="Calculation_PFTitle">Popular Low Carbs Food</div>
            <div className="Calculation_PFCards">{this.foodCard()}</div>
          </div>
          <div className="Calculation_CategoryFoodBlock">
            <div className="Calculation_CFTitle">Category</div>
            <div className="Calculation_CFMenuHolder">
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_Menu">Chapati</div>
              <div className="Calculation_CFCards">{this.foodCard()}</div>
            </div>
          </div>

          {this.state.chartShow && (
            <div className="Calculation_Popup">
              <div
                className="Calculation_PopupOverlay"
                onClick={this.chartShowChange}
              ></div>
              <div className="Calculation_PopupContainer">
                {this.foodCart()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
